module.exports = __webpack_public_path__ + "static/media/pusins_vining_gonzalez.442dafdf.jpg";